import React from 'react';
import { Button, Input, Select } from 'antd';
import { ArrowRightOutlined } from "@ant-design/icons";

const { TextArea } = Input;
const { Option } = Select;

const StepBasicInfo = ({ onNext, onBack, formData, updateField }) => {
  return (
    <div className='step-container'>
      <div className='step-content'>
        <div className='step-header'>          
          <div className='step-title'>Basic Info</div>
          <div className='step-subtitle'>Identity and scope for this rule.</div>
        </div>

        <div className='step-form'>
          <div className='step-group'>
            <div className='step-form-label'>Rule Name</div>
            <Input
              placeholder="Enter Rule Name"
              value={formData.ruleName}
              onChange={(e) => updateField('ruleName', e.target.value)}             
              className='Input-border w-100'
            />
          </div>

          <div className='step-group'>
            <div className='step-form-label'>Storefront</div>
            <Select
              className='Input-border InputSelect w-100'
              value={formData.storefront || undefined}
              placeholder="Select storefront"
              allowClear
              onChange={(value) => updateField('storefront', value || '')}
            >
              <Option value="UAT">UAT</Option>
              <Option value="US">US</Option>
              <Option value="UK">UK</Option>
              <Option value="DE">DE</Option>
              <Option value="INT">INT</Option>
            </Select>
          </div>

          <div className='step-group'>
            <div className='step-form-label'>Rule Description (Customer Facing)</div>
            <TextArea
              rows={4}
              maxLength={50}
              value={formData.ruleDescription}
              onChange={(e) => updateField('ruleDescription', e.target.value)}
              style={{ resize: 'none', borderRadius: 8 }}
              className='Input-border w-100'
            />
            <div className='step-form-hint'>Max 50 Characters</div>
          </div>
        </div>

        <div className='step-footer'>
          <Button type="primary" className='btn-p' onClick={onNext}>
            Next: Benefit & Mechanic
            <ArrowRightOutlined />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StepBasicInfo;
